
import {Component, Vue} from 'vue-property-decorator';
import {eRunStatus} from '@/store/stead/runner.store';
import {RunVariable} from '@/models/run.model';

@Component
  export default class SbRunnerFormVariables extends Vue {
    // Les props
    // Les propriétés
    private varRule = [(v: string) => v.length > 0 || 'Value is required'];
    private isValid: boolean = false

    // Les propriétés calculées
    private get runner() {
      return this.$store.state.runner
    }

    private get variables(): RunVariable[] {
      // console.log('variables:', this.runner.getVariables())
      return this.runner.compiler.variables
    }

    private get loadedVariables(): boolean {
      return this.runner.runStatus === eRunStatus.INITIALIZATION_TODO
    }

    // Les hooks
    // Les méthodes surveillées
    // Les méthodes d'instance
    // Les méthodes statiques
  }
